import Links from "../../../utils/Links";

const state = {
    permissions: []
};
const getters = {
    permissions(state) {
        return state.permissions;
    },
};
const actions = {
    getPermissions({ commit }) {
        var user = JSON.parse(localStorage.getItem("user"));
        if (user) {

            let url = process.env.VUE_APP_BASE_URL + '/api/get-permissions-for-user';

            axios.post(url, { roleName: user.user_role })
                .then((res) => {
                    let result1 = Links;
                    let result2 = res.data;

                    var result = result2.filter(function (o1) {
                        if (o1.module_is_show === 1 && o1.module_path) {
                            return result1.some(function (o2) {
                                return o2.to.name === o1.module_path
                            })
                        }
                    });

                    commit("savePermissions", result);
                    console.log(result, 'savePermissionsResult');
                })
        }

    },
};
const mutations = {
    savePermissions(state, permissions) {
        state.permissions = [...permissions];
    }
};
export default {
    state,
    actions,
    mutations,
    getters
};
